import { Controller } from "@hotwired/stimulus"

// Multi-select offer picker · promo wizard step 2.
// Quick-action buttons toggle subsets of the visible offers grid.
//
//   <div data-controller="promo-targets">
//     <button data-action="click->promo-targets#selectAll">Toutes</button>
//     <button data-action="click->promo-targets#selectType" data-type="Course">Que les cours</button>
//     <button data-action="click->promo-targets#clearAll">Tout décocher</button>
//     <label data-promo-targets-target="row" data-type="Course">
//       <input type="checkbox" data-promo-targets-target="checkbox" ...>
//     </label>
//   </div>
export default class extends Controller {
  static targets = ["row", "checkbox"]

  selectAll(event) {
    event.preventDefault()
    this.checkboxTargets.forEach(cb => { cb.checked = true })
  }

  clearAll(event) {
    event.preventDefault()
    this.checkboxTargets.forEach(cb => { cb.checked = false })
  }

  selectType(event) {
    event.preventDefault()
    const type = event.currentTarget.dataset.type
    this.rowTargets.forEach(row => {
      const cb = row.querySelector("input[type=checkbox]")
      if (!cb) return
      cb.checked = (row.dataset.type === type)
    })
  }
}
